function decodeBasicEntities(str) {
    return String(str || '')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&');
}

function normalizeMarkdownLinksToHtml(caption) {
    return String(caption || '').replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
        (_m, label, href) => `<a href="${href}">${label}</a>`
    );
}

/**
 * Parse Telegram HTML-ish caption into a node tree for preview.
 * Supports: <b>/<strong>, <i>/<em>, <u>, <s>/<strike>/<del>, <a href>,
 * markdown [label](url), and bare http(s) URLs.
 */
export function parseCaptionNodes(caption) {
    const src = normalizeMarkdownLinksToHtml(caption);
    let i = 0;

    function parseNodes(stopTag = null) {
        const nodes = [];
        while (i < src.length) {
            if (stopTag && src.startsWith(`</${stopTag}>`, i)) {
                i += stopTag.length + 3;
                break;
            }

            if (src[i] === '<') {
                const closeMatch = src.slice(i).match(/^<\/([a-zA-Z]+)>/);
                if (closeMatch) {
                    nodes.push({ type: 'text', value: src[i] });
                    i += 1;
                    continue;
                }

                const openMatch = src.slice(i).match(/^<(b|strong|i|em|u|s|strike|del|a)(\s+[^>]*)?>/i);
                if (openMatch) {
                    const rawTag = openMatch[1].toLowerCase();
                    const tag =
                        rawTag === 'strong'
                            ? 'b'
                            : rawTag === 'em'
                                ? 'i'
                                : rawTag === 'strike' || rawTag === 'del'
                                    ? 's'
                                    : rawTag;
                    const full = openMatch[0];
                    i += full.length;

                    let href = '';
                    if (tag === 'a') {
                        const hrefMatch =
                            full.match(/\shref\s*=\s*"([^"]*)"/i) || full.match(/\shref\s*=\s*'([^']*)'/i);
                        href = decodeBasicEntities(hrefMatch?.[1] || '');
                    }

                    const children = parseNodes(rawTag);
                    nodes.push({ type: tag, href, children });
                    continue;
                }

                nodes.push({ type: 'text', value: src[i] });
                i += 1;
                continue;
            }

            const rest = src.slice(i);
            const urlMatch = rest.match(/^(https?:\/\/[^\s<]+)/);
            if (urlMatch) {
                nodes.push({
                    type: 'a',
                    href: urlMatch[1],
                    children: [{ type: 'text', value: urlMatch[1] }],
                });
                i += urlMatch[1].length;
                continue;
            }

            const nextSpecial = rest.search(/<|https?:\/\//);
            const end = nextSpecial === -1 ? rest.length : nextSpecial;
            const chunk = rest.slice(0, Math.max(end, 1));
            nodes.push({ type: 'text', value: chunk });
            i += chunk.length;
        }
        return nodes;
    }

    return parseNodes(null);
}

export function groupButtonsByRow(buttons = []) {
    const map = new Map();
    buttons.forEach((btn, index) => {
        const row = Number.isFinite(Number(btn.row)) ? Number(btn.row) : 0;
        if (!map.has(row)) map.set(row, []);
        map.get(row).push({ ...btn, _index: index });
    });
    return Array.from(map.entries())
        .sort((a, b) => a[0] - b[0])
        .map(([, rowButtons]) => rowButtons);
}
